import { BillingDataSubscriptionInfoStatus } from 'reactApp/modules/billingData/billingData.types';

const PHOTO_SIZE_IN_BYTES = 3989751.320018579;

export const getNumberOfShot = (space: number) => `+ ${Math.floor(space / PHOTO_SIZE_IN_BYTES).toLocaleString('ru-RU')} снимков`;

type StatusKeys =
    | BillingDataSubscriptionInfoStatus.ACTIVE
    | BillingDataSubscriptionInfoStatus.SUSPENDED
    | BillingDataSubscriptionInfoStatus.FINISHED;

const STATUS: Record<StatusKeys, string> = {
    [BillingDataSubscriptionInfoStatus.ACTIVE]: 'Подключено',
    [BillingDataSubscriptionInfoStatus.SUSPENDED]: 'Закончится',
    [BillingDataSubscriptionInfoStatus.FINISHED]: 'Завершена',
};

export const getStatus = (status: BillingDataSubscriptionInfoStatus = BillingDataSubscriptionInfoStatus.ACTIVE) => STATUS[status];
